import { render, staticRenderFns } from "./CustomerBill.vue?vue&type=template&id=192b5c09&"
import script from "./CustomerBill.vue?vue&type=script&lang=js&"
export * from "./CustomerBill.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports